import { render, staticRenderFns } from "./CreateVisit.vue?vue&type=template&id=238f12f0"
import script from "./CreateVisit.vue?vue&type=script&lang=ts"
export * from "./CreateVisit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports